import { render, staticRenderFns } from "./BtnAtualizarDespesa.vue?vue&type=template&id=9bf710da"
import script from "./BtnAtualizarDespesa.vue?vue&type=script&lang=js"
export * from "./BtnAtualizarDespesa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports